export type JsonObject = Record<string, unknown>;

export const isPlainObject = (value: unknown): value is JsonObject =>
  value !== null &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  Object.getPrototypeOf(value) === Object.prototype;

export const applyMergePatch = (target: unknown, patch: unknown): unknown => {
  if (!isPlainObject(patch)) {
    return patch;
  }
  const result: JsonObject = isPlainObject(target) ? { ...target } : {};
  for (const [key, value] of Object.entries(patch)) {
    if (key === "__proto__") {
      continue;
    }
    if (value === null) {
      delete result[key];
    } else {
      result[key] = applyMergePatch(result[key], value);
    }
  }
  return result;
};

export const mergePatchObject = (target: unknown, patch: JsonObject): JsonObject =>
  applyMergePatch(target, patch) as JsonObject;

export const composeMergePatches = (first: JsonObject, second: JsonObject): JsonObject => {
  const result: JsonObject = { ...first };
  for (const [key, value] of Object.entries(second)) {
    if (key === "__proto__") {
      continue;
    }
    const previous = result[key];
    result[key] =
      isPlainObject(value) && isPlainObject(previous)
        ? composeMergePatches(previous, value)
        : value;
  }
  return result;
};
